var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSubGroups = function SvgSubGroups(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5C7 1.5335 7.89543 0.75 9 0.75H13C14.1046 0.75 15 1.5335 15 2.5V6C15 6.9665 14.1046 7.75 13 7.75H9C7.89543 7.75 7 6.9665 7 6V2.5Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.875C8.75 15.2537 9.25368 14.75 9.875 14.75H12.125C12.7463 14.75 13.25 15.2537 13.25 15.875V18.125C13.25 18.7463 12.7463 19.25 12.125 19.25H9.875C9.25368 19.25 8.75 18.7463 8.75 18.125V15.875Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24219 15.875C1.24219 15.2537 1.74587 14.75 2.36719 14.75H4.61719C5.23851 14.75 5.74219 15.2537 5.74219 15.875V18.125C5.74219 18.7463 5.23851 19.25 4.61719 19.25H2.36719C1.74587 19.25 1.24219 18.7463 1.24219 18.125V15.875Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.251 15.875C16.251 15.2537 16.7547 14.75 17.376 14.75H19.626C20.2473 14.75 20.751 15.2537 20.751 15.875V18.125C20.751 18.7463 20.2473 19.25 19.626 19.25H17.376C16.7547 19.25 16.251 18.7463 16.251 18.125V15.875Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.0098V12.0098C3.5 11.4575 3.94772 11.0098 4.5 11.0098H17.5C18.0523 11.0098 18.5 11.4575 18.5 12.0098V15.0098",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.01562L11 14.7129",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSubGroups);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sub-groups.9052407e0d150a8d9bd0027fb25e7c12.svg";